<div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
  <table class="w-full table border border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden">
    <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
      <tr class="bg-gray-100">
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Sr. No.</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Product Code</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Product Name</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Qty</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Status</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let order of orders; let i = index" class="text-xs sm:text-sm lg:text-[15px]">
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          {{ i + 1 }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          {{ order.product_code }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          {{ order.product_name }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          {{ order.quantity }}
        </td>
        <td class="py-1 px-2 text-center text-[#E12222] border border-[#d9d9dd] border-l-0 border-b-0">
          {{ order.status | titlecase }}
        </td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">
          <button
            (click)="requestApproval(order)"
            [disabled]="order.status === 'approval_waiting'"
            [ngClass]="{
              'bg-blue-500 hover:bg-blue-700 text-white': order.status !== 'approval_waiting',
              'bg-gray-400 text-gray-200 cursor-not-allowed': order.status === 'approval_waiting'
            }"
            class="font-bold py-1 px-3 rounded text-xs transition-all duration-200"
            [title]="order.status === 'approval_waiting' ? 'Approval request sent' : 'Request for approval'"
          >
            {{ order.status === 'approval_waiting' ? 'Pending Approval' : 'Request for approval' }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
